module.exports = __webpack_public_path__ + "static/media/CouponCategories.d1dcea54.png";